<ngx-scanner-qrcode
  class="mb-4"
  #scanner
  [config]="scannerConfig"
  (event)="onScanned($event)"
  [isBeep]="shouldBeep"
></ngx-scanner-qrcode>
